<template>
  <gv-dropdown>
    <template #default="{ open, toggleOpen }">
      <button class="flex" :aria-expanded="open" @click="toggleOpen()">
        <img
          src="@/common/assets/icons/map.png"
          width="32"
          height="32"
          class="cursor-pointer rounded border"
          alt="Select map layer"
          :class="{ 'border-indigo-450': open, 'border-transparent hover:bg-grey-50': !open }"
        />
      </button>
    </template>
    <template #menu>
      <gv-menu class="flex flex-row !rounded">
        <div class="flex flex-col px-2 pb-2 pt-1">
          <gv-type breakpoint="none" uplifted-variant="caption" text="OSM" />
          <button @click="map.setOsmEnabled(true)">
            <img
              src="@/common/assets/icons/osm.png"
              width="48"
              height="48"
              class="cursor-pointer rounded border"
              :class="{
                'border-indigo-450': map.osmEnabled,
                'border-transparent': !map.osmEnabled,
              }"
              alt="OpenStreetMap layer"
            />
          </button>
        </div>
        <div class="mb-2 mt-6 w-px bg-grey-50 transition-all"></div>
        <div class="flex flex-col px-2 pb-2 pt-1">
          <gv-type breakpoint="none" uplifted-variant="caption" text="Mapbox" />
          <div class="flex flex-row gap-x-1">
            <button @click="map.setStyle(MapboxStyle.default)">
              <img
                src="@/common/assets/icons/map.png"
                width="48"
                height="48"
                alt="Map layer"
                class="cursor-pointer rounded border"
                :class="{
                  'border-indigo-450': map.style === MapboxStyle.default && !map.osmEnabled,
                  'border-transparent': map.style != MapboxStyle.default || map.osmEnabled,
                }"
              />
            </button>
            <button @click="map.setStyle(MapboxStyle.satellite)">
              <img
                src="@/common/assets/icons/satellite.png"
                width="48"
                height="48"
                alt="Satellite layer"
                class="cursor-pointer rounded border"
                :class="{
                  'border-indigo-450': map.style === MapboxStyle.satellite && !map.osmEnabled,
                  'border-transparent': map.style != MapboxStyle.satellite || map.osmEnabled,
                }"
              />
            </button>
          </div>
        </div>
      </gv-menu>
    </template>
  </gv-dropdown>
</template>

<script setup lang="ts">
import { MapboxStyle } from '@/features/hazards/constants';
import { useMapStore } from '@/features/hazards/presentation/bloc';

const map = useMapStore();
</script>
